// アプリイベント関係
const appEvent = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    closedCount: 0 // ブラウザクローズカウンタ
  },
  getters: {
  },
  mutations: {
    setClosedCount: (state, count) => {
      state.closedCount = count
    },
    onAppClosed: (state) => {
      state.closedCount++
    }
  },
  actions: {
    setClosedCount: async ({ commit }, count) => {
      await commit('setClosedCount', count) 
    },
    /**
     * アプリが閉じられたことを親ウィンドウに通知する
     * 
     * 【概要】
     * 別タブで表示した画面（資料検索画面）が閉じられたことを、
     * 親ウィンドウに通知し、親ウィンドウ側の処理を実行する。
     * （用途例：資料検索でノートを追加した場合に、親ウィンドウ側でノート一覧をリロードして最新表示にする）
     * 
     * 【詳細説明】
     * 本メソッドを実行すると、store.state.appEvent.closedCountがカウントアップされる。
     * /store/index.js内の変数saveStoragePathに設定した'appEvent.closedCount'の記述により、
     * ローカルストレージにも値が保存される。
     * ローカルストレージが更新されると、/util/app-event.js内に記述した、
     * window.addEventListener('storage', () => {})
     * の処理が実行される。
     * 同ファイル(/util/app-event.js)内のonLocalStorageValuesChanged()メソッドが実行される。
     * 
     * @param {*} param0 
     */
    onAppClosed: async ({ commit }) => {
      await commit('onAppClosed') 
    }
  }
}

export default appEvent
